// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge-module--badge--27-VC"};